import { graphql, useStaticQuery } from 'gatsby'

export const benefitImage = graphql`
  fragment benefitImage on File {
    childImageSharp {
      fluid(maxWidth: 240, maxHeight: 192, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`

export const benefitImageQuery = graphql`
  query {
    earningsImage: file(
      relativePath: { eq: "benefits/ganhos_diferenciados.png" }
    ) {
      ...benefitImage
    }
    educationImage: file(relativePath: { eq: "benefits/educacao.png" }) {
      ...benefitImage
    }
    healthImage: file(relativePath: { eq: "benefits/saude.png" }) {
      ...benefitImage
    }
    acknowledgmentImage: file(
      relativePath: { eq: "benefits/reconhecimento.png" }
    ) {
      ...benefitImage
    }
    onlineSalesImage: file(
      relativePath: { eq: "benefits/vendas_internet.png" }
    ) {
      ...benefitImage
    }
    careerPlanImage: file(relativePath: { eq: "benefits/career_plan.jpg" }) {
      ...benefitImage
    }
    funAndEasyImage: file(relativePath: { eq: "benefits/fun_and_easy.jpg" }) {
      ...benefitImage
    }
    salesSupportImage: file(
      relativePath: { eq: "benefits/sales_support.jpg" }
    ) {
      ...benefitImage
    }
    sellOnlineImage: file(relativePath: { eq: "benefits/sell_online.jpg" }) {
      ...benefitImage
    }
    trainingImage: file(relativePath: { eq: "benefits/training.jpg" }) {
      ...benefitImage
    }
    amazingProductsImage: file(
      relativePath: { eq: "benefits/amazing_products.jpg" }
    ) {
      ...benefitImage
    }
    feelAppreciatedImage: file(
      relativePath: { eq: "benefits/feel_appreciated.jpg" }
    ) {
      ...benefitImage
    }
    eventsCO: file(
      relativePath: { eq: "benefits/es-co/events.png" }
    ) {
      ...benefitImage
    }
    onlineSalesCO: file(
      relativePath: { eq: "benefits/es-co/online_sales.png" }
    ) {
      ...benefitImage
    }
    trainingCO: file(
      relativePath: { eq: "benefits/es-co/training.png" }
    ) {
      ...benefitImage
    }
    salesCampaignsCO: file(
      relativePath: { eq: "benefits/es-co/sales_campaigns.png" }
    ) {
      ...benefitImage
    }
    exclusiveAppCL: file(
      relativePath: { eq: "benefits/es-cl/app-exclusiva.jpg" }
    ) {
      ...benefitImage
    }
    opportunityCL: file(
      relativePath: { eq: "benefits/es-cl/oportunidade-ganancias.jpg" }
    ) {
      ...benefitImage
    }
    wellBeingCL: file(
      relativePath: { eq: "benefits/es-cl/bienestar-integral.jpg" }
    ) {
      ...benefitImage
    }
    eventsCL: file(
      relativePath: { eq: "benefits/es-cl/eventos-y-reconocimientos.jpg" }
    ) {
      ...benefitImage
    }
    productsCL: file(
      relativePath: { eq: "benefits/es-cl/productos-inovadores.jpg" }
    ) {
      ...benefitImage
    }
  }
`

/**
 * @property earningsImage
 * @property educationImage
 * @property healthImage
 * @property acknowledgmentImage
 * @property onlineSalesImage
 */
const useBenefitImage = () => {
  const data = useStaticQuery(benefitImageQuery)

  return data
}

export default useBenefitImage
